import PropTypes from 'prop-types';
import React from 'react';

import {
    Pagination as SourcePagination
} from 'SourceComponent/Pagination/Pagination.component';

import './Pagination.override.style';

/** @namespace PeggysagePwa/Component/Pagination/Component */
export class PaginationComponent extends SourcePagination {
    static propTypes = {
        ...SourcePagination.propTypes,
        pageSize: PropTypes.number.isRequired,
        pagesCount: PropTypes.number.isRequired,
        totalItems: PropTypes.number.isRequired,
        onShowMoreButtonClick: PropTypes.func.isRequired
    };

    renderShowMoreButton() {
        const {
            currentPage,
            totalPages,
            pagesCount,
            totalItems,
            onShowMoreButtonClick
        } = this.props;

        if (
            !totalItems
            // Based on current page number
            || currentPage === totalPages
            // Based on the number of "pages" loaded (with infinite pagination)
            || pagesCount === totalPages
        ) {
            return null;
        }

        return (
            <button
              type="button"
              block="Button"
              mods={ { isHollow: true } }
              mix={ { block: 'Pagination', elem: 'Button' } }
              onClick={ onShowMoreButtonClick }
            >
                { __('Show more products') }
            </button>
        );
    }

    /**
     * Override: load more type of pagination
     * @returns {JSX.Element|*}
     */
    render() {
        const {
            isLoading,
            id,
            mix,
            // currentPage,
            totalPages,
            pageSize,
            pagesCount,
            totalItems
        } = this.props;

        if (isLoading) {
            return this.renderPlaceholder();
        }

        // This count is based on current page number
        // const currentItemsCount = currentPage === totalPages ? totalItems : currentPage * pageSize;
        // This other count is based on the number of "pages" loaded (with infinite pagination)
        const currentItemsCount = pagesCount === totalPages ? totalItems : pagesCount * pageSize;

        return (
            <div block="Pagination" id={ id } mix={ mix }>
                <p>{ __('%s products on %s', currentItemsCount, totalItems) }</p>
                { this.renderShowMoreButton() }
            </div>
        );
    }
}

export default PaginationComponent;
